export default __webpack_public_path__ + "static/media/closeIcon.97c102be.svg";